// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperContainer-cls1__bb214f363760ab7e3f00{/*!*/}.PaperContainer-cls2__d3b1b61f715b459a2432{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:flex;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperContainer-cls1__bb214f363760ab7e3f00",
	"cls2": "PaperContainer-cls2__d3b1b61f715b459a2432 PaperContainer-cls1__bb214f363760ab7e3f00"
};
export default ___CSS_LOADER_EXPORT___;
